import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("asf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

const q = (country) => (country ? `?country=${country}` : "");

export const api = {
  // auth
  register: (data) => client.post("/auth/register", data).then((r) => r.data),
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  googleSession: (session_id) => client.post("/auth/google/session", { session_id }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  updateProfile: (data) => client.put("/auth/profile", data).then((r) => r.data),
  // location
  location: (country) => client.get(`/location${q(country)}`).then((r) => r.data),
  currencyMap: () => client.get("/currency-map").then((r) => r.data),
  industries: () => client.get("/industries").then((r) => r.data),
  // catalog
  courses: (industry, country) =>
    client.get(`/courses?${industry ? `industry=${industry}&` : ""}${country ? `country=${country}` : ""}`).then((r) => r.data),
  course: (slug, country) => client.get(`/courses/${slug}${q(country)}`).then((r) => r.data),
  bundles: (country) => client.get(`/bundles${q(country)}`).then((r) => r.data),
  bundle: (slug, country) => client.get(`/bundles/${slug}${q(country)}`).then((r) => r.data),
  // webinars
  nextWebinar: (topic) => client.get(`/webinars/next?topic=${topic}`).then((r) => r.data),
  upcomingWebinars: (topic) => client.get(`/webinars/upcoming?topic=${topic}`).then((r) => r.data),
  webinarInstance: (id) => client.get(`/webinars/instance/${id}`).then((r) => r.data),
  registerWebinar: (data) => client.post("/webinars/register", data).then((r) => r.data),
  attendWebinar: (registration_id) => client.post("/webinars/attend", { registration_id }).then((r) => r.data),
  notifyMe: (data) => client.post("/webinars/notify-me", data).then((r) => r.data),
  myWebinars: () => client.get("/webinars/my").then((r) => r.data),
  // offers
  offer: (industry, country) => client.get(`/offers/${industry}${q(country)}`).then((r) => r.data),
  // checkout
  checkoutCreate: (data) => client.post("/checkout/create", data).then((r) => r.data),
  checkoutConfirm: (data) => client.post("/checkout/confirm", data).then((r) => r.data),
  myOrders: () => client.get("/orders/my").then((r) => r.data),
  invoiceBlob: (orderId) => client.get(`/orders/${orderId}/invoice.pdf`, { responseType: "blob" }).then((r) => r.data),
  // learning
  myCourses: () => client.get("/learning/my-courses").then((r) => r.data),
  learnCourse: (slug) => client.get(`/learning/course/${slug}`).then((r) => r.data),
  progress: (data) => client.post("/learning/progress", data).then((r) => r.data),
  myCertificates: () => client.get("/certificates/my").then((r) => r.data),
  verifyCertificate: (id) => client.get(`/certificates/verify/${id}`).then((r) => r.data),
  logEvent: (event, meta) => client.post("/events", { event, meta }).catch(() => {}),
  // admin
  adminAnalytics: () => client.get("/admin/analytics").then((r) => r.data),
  adminStudents: () => client.get("/admin/students").then((r) => r.data),
  adminOrders: () => client.get("/admin/orders").then((r) => r.data),
  adminRegistrations: (topic) => client.get(`/admin/registrations${topic ? `?topic=${topic}` : ""}`).then((r) => r.data),
  adminCourses: () => client.get("/admin/courses").then((r) => r.data),
  adminUpdateCourse: (slug, data) => client.put(`/admin/courses/${slug}`, data).then((r) => r.data),
  adminWebinarInstances: (topic) => client.get(`/admin/webinars/instances?topic=${topic}`).then((r) => r.data),
  adminCoupons: () => client.get("/admin/coupons").then((r) => r.data),
  adminCreateCoupon: (data) => client.post("/admin/coupons", data).then((r) => r.data),
  adminDeleteCoupon: (code) => client.delete(`/admin/coupons/${code}`).then((r) => r.data),
  adminNotifyRequests: () => client.get("/admin/notify-requests").then((r) => r.data),
  adminSettings: () => client.get("/admin/settings").then((r) => r.data),
  adminUpdateSettings: (data) => client.put("/admin/settings", data).then((r) => r.data),
};

export default api;
